import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center text-primary-950">
                <i className="ri-clapperboard-fill text-xl"></i>
              </span>
              <span className="text-lg font-bold text-background-50">迷人的保姆在线观看</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              专注于《迷人的保姆》电视剧的在线播放演示与剧情资讯，提供剧集目录、剧情介绍、更新同步展示等实用功能，帮助你随时了解剧情动态。
            </p>
            <p className="mt-4 text-xs text-background-400 leading-relaxed max-w-md">
              说明：本站播放区域为前端功能演示，不接入真实视频源，仅用于展示观看界面与交互效果。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/category">内容导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-background-300 hover:text-accent-300 transition-colors">
                  剧集分类
                </Link>
              </li>
              <li>
                <Link to="/detail/nanny" className="text-background-300 hover:text-accent-300 transition-colors">
                  《迷人的保姆》详情
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-300 transition-colors">
                  关于 / 帮助
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/about#contact">联系与反馈</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:hello@charmingnanny.example.com" className="hover:text-accent-300 transition-colors">
                  hello@charmingnanny.example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>更新时间：每周五、周六</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line"></i>
                <span>内容仅供剧情交流参考</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 迷人的保姆在线观看 · 高清电视剧在线播放平台</p>
          <p>本站内容与图片均为演示用途，相关版权归原权利方所有。</p>
        </div>
      </div>
    </footer>
  );
}